"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _invariant = _interopRequireDefault(require("../../utils/common/invariant"));

var _logger = _interopRequireDefault(require("../../utils/common/logger"));

var _common = require("../common");

var _WorkerBridge = _interopRequireDefault(require("./WorkerBridge"));

var _common2 = require("./common");

// don't import the whole utils/ here!
var {
  SETUP: SETUP,
  FIND: FIND,
  QUERY: QUERY,
  COUNT: COUNT,
  BATCH: BATCH,
  UNSAFE_RESET_DATABASE: UNSAFE_RESET_DATABASE,
  GET_LOCAL: GET_LOCAL,
  SET_LOCAL: SET_LOCAL,
  REMOVE_LOCAL: REMOVE_LOCAL,
  GET_DELETED_RECORDS: GET_DELETED_RECORDS,
  DESTROY_DELETED_RECORDS: DESTROY_DELETED_RECORDS,
  EXPERIMENTAL_FATAL_ERROR: EXPERIMENTAL_FATAL_ERROR,
  CLEAR_CACHED_RECORDS: CLEAR_CACHED_RECORDS
} = _common2.actions;

var LokiJSAdapter =
/*#__PURE__*/
function () {
  function LokiJSAdapter(options) {
    var _options$useWebWorker;

    this._options = options;
    var {
      schema: schema,
      migrations: migrations,
      dbName: dbName
    } = options;
    var useWebWorker = null !== (_options$useWebWorker = options.useWebWorker) && void 0 !== _options$useWebWorker ? _options$useWebWorker : 'test' !== process.env.NODE_ENV;
    this.workerBridge = new _WorkerBridge.default(useWebWorker);
    this.schema = schema;
    this.migrations = migrations;
    this._dbName = dbName;

    if ('production' !== process.env.NODE_ENV) {
      (0, _invariant.default)('useWebWorker' in options, 'LokiJSAdapter `useWebWorker` option is required. Pass `{ useWebWorker: false }` to adopt the new behavior, or `{ useWebWorker: true }` to supress this warning with no changes');
      (0, _invariant.default)('useIncrementalIndexedDB' in options, 'LokiJSAdapter `useIncrementalIndexedDB` option is required. Pass `{ useIncrementalIndexedDB: true }` to adopt the new behavior, or `{ useIncrementalIndexedDB: false }` to supress this warning with no changes'); // TODO(2021-05): Remove this

      (0, _invariant.default)(!('migrationsExperimental' in options), 'LokiJSAdapter `migrationsExperimental` option has been renamed to `migrations`'); // TODO(2021-05): Remove this

      (0, _invariant.default)(!('experimentalUseIncrementalIndexedDB' in options), 'LokiJSAdapter `experimentalUseIncrementalIndexedDB` option has been renamed to `useIncrementalIndexedDB`');
      (0, _common.validateAdapter)(this);
    }

    this.workerBridge.send(SETUP, [options], function callback(result) {
      return (0, _common.devSetupCallback)(result, options.onSetUpError);
    }, 'immutable', 'immutable');
  }

  var _proto = LokiJSAdapter.prototype;

  _proto.testClone = function testClone(options = {}) {
    return new Promise(function ($return) {
      // Ensure data is saved to memory
      // $FlowFixMe
      var {
        executor: executor
      } = this.workerBridge._worker._worker;
      executor.loki.close(); // Copy

      var lokiAdapter = executor.loki.persistenceAdapter; // $FlowFixMe

      return $return(new LokiJSAdapter((0, _extends2.default)({}, this._options, {
        dbName: this._dbName,
        schema: this.schema
      }, this.migrations ? {
        migrations: this.migrations
      } : {}, {
        _testLokiAdapter: lokiAdapter
      }, options)));
    }.bind(this));
  };

  _proto.find = function find(table, id, callback) {
    (0, _common.validateTable)(table, this.schema);
    this.workerBridge.send(FIND, [table, id], callback, 'immutable', 'shallowCloneDeepObjects');
  };

  _proto.query = function query(_query, callback) {
    (0, _common.validateTable)(_query.table, this.schema); // SerializedQueries are immutable, so we need no copy

    this.workerBridge.send(QUERY, [_query], callback, 'immutable', 'shallowCloneDeepObjects');
  };

  _proto.count = function count(query, callback) {
    (0, _common.validateTable)(query.table, this.schema); // SerializedQueries are immutable, so we need no copy

    this.workerBridge.send(COUNT, [query], callback, 'immutable', 'immutable');
  };

  _proto.batch = function batch(operations, callback) {
    var _this = this;

    operations.forEach(function ([, table]) {
      return (0, _common.validateTable)(table, _this.schema);
    }); // batches are only strings + raws which only have JSON-compatible values, rest is immutable

    this.workerBridge.send(BATCH, [operations], callback, 'shallowCloneDeepObjects', 'immutable');
  };

  _proto.getDeletedRecords = function getDeletedRecords(table, callback) {
    (0, _common.validateTable)(table, this.schema);
    this.workerBridge.send(GET_DELETED_RECORDS, [table], callback, 'immutable', 'immutable');
  };

  _proto.destroyDeletedRecords = function destroyDeletedRecords(table, recordIds, callback) {
    (0, _common.validateTable)(table, this.schema);
    this.workerBridge.send(DESTROY_DELETED_RECORDS, [table, recordIds], callback, 'immutable', 'immutable');
  };

  _proto.unsafeResetDatabase = function unsafeResetDatabase(callback) {
    this.workerBridge.send(UNSAFE_RESET_DATABASE, [], callback, 'immutable', 'immutable');
  };

  _proto.getLocal = function getLocal(key, callback) {
    this.workerBridge.send(GET_LOCAL, [key], callback, 'immutable', 'immutable');
  };

  _proto.setLocal = function setLocal(key, value, callback) {
    this.workerBridge.send(SET_LOCAL, [key, value], callback, 'immutable', 'immutable');
  };

  _proto.removeLocal = function removeLocal(key, callback) {
    this.workerBridge.send(REMOVE_LOCAL, [key], callback, 'immutable', 'immutable');
  } // dev/debug utility
  ;

  // (experimental)
  _proto._fatalError = function _fatalError(error) {
    this.workerBridge.send(EXPERIMENTAL_FATAL_ERROR, [error], function () {}, 'immutable', 'immutable');
  } // (experimental)
  ;

  _proto._clearCachedRecords = function _clearCachedRecords() {
    this.workerBridge.send(CLEAR_CACHED_RECORDS, [], function () {}, 'immutable', 'immutable');
  };

  _proto._debugDignoseMissingRecord = function _debugDignoseMissingRecord(table, id) {
    var lokiExecutor = this._executor;

    if (lokiExecutor) {
      var lokiCollection = lokiExecutor.loki.getCollection(table); // if we can find the record by ID, it just means that the record cache ID was corrupted

      var didFindById = !!lokiCollection.by('id', id);

      _logger.default.log("Did find ".concat(table, "#").concat(id, " in Loki collection by ID? ").concat(didFindById)); // if we can't, but can filter to it, it means that Loki indices are corrupted


      var didFindByFilter = !!lokiCollection.data.filter(function (doc) {
        return doc.id === id;
      });

      _logger.default.log("Did find ".concat(table, "#").concat(id, " in Loki collection by filtering the collection? ").concat(didFindByFilter));
    }
  };

  (0, _createClass2.default)(LokiJSAdapter, [{
    key: "_executor",
    get: function get() {
      // $FlowFixMe
      return this.workerBridge._worker._worker.executor;
    }
  }]);
  return LokiJSAdapter;
}();

exports.default = LokiJSAdapter;